<script setup lang="ts">
import { useChatStore } from '@/stores/chat'

const chatStore = useChatStore()
</script>

<template>
  <header class="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between safe-area-top">
    <div class="flex items-center gap-3">
      <!-- Back button -->
      <button
        v-if="chatStore.currentStepIndex > 0 && !chatStore.isSubmitting"
        @click="chatStore.goBack()"
        class="p-2 -ml-2 rounded-full hover:bg-gray-100 transition-colors"
        aria-label="Go back"
      >
        <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      <!-- Logo/Title -->
      <div class="flex items-center gap-3">
        <img
          src="/emily-avatar.jpg"
          alt="Emily"
          class="w-10 h-10 rounded-full object-cover"
        />
        <div>
          <p class="font-semibold text-gray-800 leading-tight">Emily</p>
          <p class="text-xs text-gray-500">First Advantage</p>
        </div>
      </div>
    </div>

    <!-- Status indicator -->
    <div class="flex items-center gap-2">
      <span class="w-2 h-2 bg-green-500 rounded-full"></span>
      <span class="text-sm text-gray-500">Online</span>
    </div>
  </header>
</template>

<style scoped>
.safe-area-top {
  padding-top: max(0.75rem, env(safe-area-inset-top));
}
</style>
